import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await api.post('/api/auth/login', { email, password });
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('user', JSON.stringify(res.data.user));
            
            if (res.data.user.role === 'admin') {
                navigate('/admin');
            } else if (res.data.user.role === 'expert') {
                navigate('/dashboard/expert');
            } else if (res.data.user.role === 'investor') {
                navigate('/dashboard/investor');
            } else if (res.data.user.role === 'observer') {
                navigate('/dashboard/observer');
            } else {
                navigate('/dashboard');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-slate-900">
            <div className="glass p-8 rounded-3xl max-w-md w-full border border-white/10 shadow-2xl relative">
                <Link to="/" className="absolute top-4 left-4 text-slate-500 hover:text-emerald-400 transition-colors">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                </Link>
                <h1 className="text-3xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-cyan-400 mt-4">Welcome Back</h1>
                <p className="text-slate-400 mb-8">Login to Silicon Himalayas</p>

                {error && <div className="bg-rose-500/20 text-rose-400 p-3 rounded-xl mb-6 text-sm border border-rose-500/30">{error}</div>}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-400 mb-2">Email Address</label>
                        <input 
                            type="email" 
                            required 
                            className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-emerald-500 transition"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <div className="flex justify-between mb-2">
                            <label className="text-sm font-medium text-slate-400">Password</label>
                            <Link to="/forgot-password" size="sm" className="text-xs text-cyan-400 hover:text-cyan-300">Forgot?</Link>
                        </div>
                        <input 
                            type="password" 
                            required 
                            className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-emerald-500 transition"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button 
                        type="submit" 
                        disabled={loading}
                        className="w-full py-3 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-400 hover:to-cyan-400 text-white font-bold rounded-xl shadow-lg hover:shadow-emerald-500/20 transition-all active:scale-95 disabled:opacity-50 hover:scale-[1.02]"
                    >
                        {loading ? 'Authenticating...' : 'Sign In'}
                    </button>
                </form>

                <p className="mt-8 text-center text-slate-500 text-sm">
                    Don't have an account? <Link to="/register" className="text-emerald-400 hover:text-emerald-300 font-medium">Register Now</Link>
                </p>
            </div>
        </div>
    );
}
